import { useUserEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import React, { useRef, useState } from 'react';

import { YesNoBlank } from '@/__generated__/employmentSpecialRelationshipsPastQuery.graphql';
import { BasicList } from '@/components/survey/common/ui/BasicList';
import { CheckList } from '@/components/survey/common/ui/CheckList';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/survey/common/ui/Combobox';
import common from '@/components/survey/common/ui/styles/common.module.scss';
import { birthToYYMD } from '@/components/survey/common/utils';
import { employeesAtom } from '@/lib/stores/survey/common';

export const SpecialRelationshipsSearchEmployee = ({
  selectedAnswer,
  isCheckedEmployee,
  onToggleEmployee
}: {
  selectedAnswer: YesNoBlank;
  isCheckedEmployee: (id: string) => boolean;
  onToggleEmployee: (id: string) => void;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState('');
  const { sendClickEvent } = useUserEventLogger();

  const employees = useAtomValue(employeesAtom);

  return (
    <section className={'pt-6'}>
      <h3 className={common.section_title}>
        {selectedAnswer === 'yes' ? '직원 중에서 해당하는 분들을 모두 선택해주세요' : '해당 기간 근무한 직원 목록에서 확인해보세요.'}
      </h3>
      <div>
        <Command value={searchValue} onChange={() => setSearchValue(inputRef.current?.value || '')}>
          <CommandInput
            ref={inputRef}
            value={searchValue}
            placeholder={'이름 검색'}
            onReset={() => setSearchValue('')}
            onFocus={() => {
              sendClickEvent('survey_special-relationships_search');
            }}
          />
          <CommandList>
            <CommandEmpty>‘{searchValue}’에 대한 검색 결과가 없어요.</CommandEmpty>
            <CommandGroup tabIndex={0}>
              {employees?.map((employee) => {
                if (selectedAnswer === 'yes') {
                  return (
                    <CommandItem key={employee.id} className={'mb-3 last:mb-0'}>
                      <CheckList value={employee.id} checked={isCheckedEmployee(employee.id)} onChange={() => onToggleEmployee(employee.id)}>
                        {employee.name} ({birthToYYMD(employee.birthday)})
                      </CheckList>
                    </CommandItem>
                  );
                }
                return (
                  <CommandItem key={employee.id} className={'border-b border-b-gray-100 last:border-b-0'}>
                    <BasicList>
                      {employee.name} ({birthToYYMD(employee.birthday)})
                    </BasicList>
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </div>
    </section>
  );
};
